import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@godaddy/react-mintl';
import Link from '@ux/link';

import { useRootProps } from '../UserDataProvider';

const CreateAccount = ({ createAccountLink, appEid }) => {
  const { formatMessage } = useIntl();

  const { privateLabelName } = useRootProps();

  const pageEid = appEid.extend('create_account');
  const createAccountLinkEid = pageEid('create_account_link.link.click') || '';

  const messages = {
    newCustomerHeading:
      formatMessage({ id: 'Shared:AccountTray:NewCustomerHeading' }),
    newCustomerMessage:
      formatMessage({ id: 'Shared:AccountTray:NewCustomerMessage' }, { privateLabelName }),
    createAccountMessage:
      formatMessage({ id: 'Shared:AccountTray:CreateAccountMessage' }),
    createAccountLinkText:
      formatMessage({ id: 'Shared:AccountTray:CreateAccount' })
  };

  return (
    <div className='create-my-account-section account-info-section'>
      <div className='account-info-title'>
        <span>{ messages.newCustomerHeading }</span>
      </div>
      <div className='account-info-text'>
        <span>{ messages.newCustomerMessage }</span>{ ' ' }
        <span>{ messages.createAccountMessage }</span>
      </div>
      <Link
        className='account-info-section-link'
        href={ createAccountLink }
        data-eid={ createAccountLinkEid }
        aria-label={ messages.createAccountLinkText }>
        <span>{ messages.createAccountLinkText }</span>
      </Link>
    </div>
  );
};

/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */
CreateAccount.propTypes = {
  createAccountLink: PropTypes.string.isRequired,
  appEid: PropTypes.func
};

export default CreateAccount;
